import type { Release } from '../releases.ts';

export default {
  version: '0.18.0',
  date: '2026-10-02',
  title: 'Passwords',
  summary: [
    'Change your own password from your account',
    'Administrators reset a member’s password with a temporary one',
    'New members choose their own password at first sign-in',
    'A command in the API container resets a password when no administrator can sign in',
  ],
  features: [
    'Change your own password from your account: the initials at the bottom of the navigation, or the person icon on the phone version. Other devices are signed out; this one stays signed in',
    'Administrators reset a member’s password in Administration → Access: a temporary password is shown once, the member is signed out everywhere and chooses a new password at next sign-in',
    'A new member chooses their own password the first time they sign in with the one they were given',
    'If no administrator can sign in, `node src/reset-password.ts <email>` in the API container sets a temporary password (see the operations guide)',
  ],
  fixes: [],
} satisfies Release;
